"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import Carousel, { CarouselSlide } from "@/components/ui/carousel";
import { GroupedSecurityCardsCarouselProps } from "./types";
import SecurityCard from "../SecurityCard";
import { SecurityCardProps } from "../SecurityCard";

const chunkCards = (arr: SecurityCardProps[], size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

const GroupedSecurityCardsCarousel = ({
  className,
  cards,
}: GroupedSecurityCardsCarouselProps) => {
  const cardChunks = chunkCards(cards, 3);
  return (
    <Carousel.Mobile
      options={{
        slides: {
          spacing: 24,
          perView: "auto",
        },
      }}
      showPagination
      className={cn(
        "md:!grid md:!grid-cols-2 md:!gap-4 lg:!grid-cols-3 md:!overflow-visible",
        className
      )}
    >
      {cardChunks.map((chunk, chunkIndex) => (
        <CarouselSlide
          key={`chunk-${chunkIndex}`}
          className="!min-w-full !w-full !md:min-w-auto md:!w-auto grid grid-cols-1 gap-6 md:!contents md:!gap-0"
        >
          {chunk.map(({ title, description, iconId }, i) => (
            <SecurityCard
              key={i}
              iconId={iconId}
              title={title}
              description={description}
              className="md:flex-auto md:min-w-0"
            />
          ))}
        </CarouselSlide>
      ))}
    </Carousel.Mobile>
  );
};

export default memo(GroupedSecurityCardsCarousel);
